export const Products = [
  {
    name: "PlayStation 5",
    imageUrl:
      "https://images.unsplash.com/photo-1606813907291-d86efa9b94db?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1352&q=80",
    description:
      "PlayStation 5 (PS5) is a home video game console developed by Sony Interactive Entertainment. Announced in 2019 as the successor to the PlayStation 4, the PS5 was released on November 12, 2020 in Australia, Japan, New Zealand, North America, Singapore, and South Korea, and November 19, 2020 onwards in other major markets except China and India.",
    price: 499,
    countInStock: 15,
    onSale: false,
    color: "",
    size: "",
  },
  {
    name: "Iphone 12",
    imageUrl:
      "https://images.unsplash.com/photo-1605787020600-b9ebd5df1d07?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1463&q=80",
    description:
      "Welcome to a new era of iPhone. Beautifully bright 6.1-inch Super Retina XDR display.1 Ceramic Shield with 4x better drop performance.2 Incredible low-light photography with Night mode on all cameras. Cinema-grade Dolby Vision video recording, editing, and playback. Powerful A14 Bionic chip. And new MagSafe accessories for easy attach and faster wireless charging.3 Let the fun begin.",
    price: 1099,
    countInStock: 10,
    onSale: false,
    color: "",
    size: "",
  },
  {
    name: "Cannon EOS-1D",
    imageUrl:
      "https://images.unsplash.com/photo-1519183071298-a2962feb14f4?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    description:
      "The EOS-1D X combines speed with image quality, to create the next generation camera for professionals. Full frame 18 megapixel sensor with Dual “DIGIC 5+” processors sets the standard, and up to 12 frames per second shooting takes it beyond.",
    price: 1300,
    countInStock: 5,
    onSale: true,
    color: "",
    size: "",
  },
  {
    name: "Amazon Alexa",
    imageUrl:
      "https://images.unsplash.com/photo-1518444065439-e933c06ce9cd?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1267&q=80",
    description:
      "It is capable of voice interaction, music playback, making to-do lists, setting alarms, streaming podcasts, playing audiobooks, and providing weather, traffic, sports, and other real-time information, such as news. Alexa can also control several smart devices using itself as a home automation system.",
    price: 50,
    countInStock: 25,
    onSale: true,
    color: "",
    size: "",
  },
  {
    name: "Audio Technica Headphones",
    imageUrl:
      "https://images.unsplash.com/photo-1558756520-22cfe5d382ca?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    description:
      "Outfitted with 45mm large-aperture dynamic drivers and an over-ear, closed-back design, the ATH-M50x headphones deliver clarity, deep bass, and extended bandwidth (15 Hz to 28 kHz) while isolating you from outside sounds.",
    price: 244,
    countInStock: 4,
    onSale: false,
    color: "",
    size: "",
  },
  {
    name: "JBL FLIP 4",
    imageUrl:
      "https://images.unsplash.com/photo-1564424224827-cd24b8915874?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1489&q=80",
    description:
      "JBL Flip 4 is the next generation in the award-winning Flip series; it is a portable Bluetooth speaker that delivers surprisingly powerful stereo sound. This compact speaker is powered by a 3000mAh rechargeable Li-ion battery that offers up to 12 hours of continuous, high-quality audio playtime.",
    price: 140,
    countInStock: 10,
    onSale: true,
    color: "",
    size: "",
  },
  {
    name: "Nike AirMax Shoes",
    imageUrl:
      "https://images.unsplash.com/photo-1654626935419-d5de88269ab3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
    price: 130,
    description: "Classic Nike AirMax Shoes never worn.",
    countInStock: 2,
    onSale: false,
    color: "",
    size: "",
  },
  {
    name: "Gucci Bamboo Perfume",
    imageUrl:
      "https://images.unsplash.com/photo-1651346753690-8a9215338c25?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
    price: 99,
    description:
      "New Gucci Bamboo Perfume. Rich Earthy Fragrance with notes of Lavender.",
    countInStock: 10,
    onSale: false,
    color: "",
    size: "",
  },
  {
    name: "Apple Watch Series 7 Cellular",
    imageUrl:
      "https://images.unsplash.com/photo-1546868871-7041f2a55e12?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1964&q=80",
    price: 350,
    description:
      "The newest release in Apple's line of watches. Includes longer battery life and cellular connectivity.",
    countInStock: 4,
    onSale: false,
    color: "",
    size: "",
  },
  {
    name: "RayBan Sunglasses",
    imageUrl:
      "https://images.unsplash.com/photo-1589782182703-2aaa69037b5b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80",
    price: 180,
    description:
      "RayBan sunglasses with Polarized lenses will keep you looking good while protecting your eyes.",
    countInStock: 5,
    onSale: true,
    color: "",
    size: "",
  },
  {
    name: "Basic Tee",
    imageUrl:
      "https://tailwindui.com/img/ecommerce-images/product-page-02-featured-product-shot.jpg",
    description: "Guy's Basic Tee Shirt in Sienna",
    onSale: false,
    price: 32,
    countInStock: 0,
    color: "Sienna",
    size: [{ name: "XS" }, { name: "S" }, { name: "M" }, { name: "LG" }],
  },
  {
    name: "Everyday Ruck Sack",
    imageUrl:
      "https://tailwindui.com/img/ecommerce-images/product-page-04-featured-product-shot.jpg",
    description:
      "Don't compromise on snack-carrying capacity with this lightweight and spacious bag. The drawstring top keeps all your favorite" +
      "chips, crisps, fries, cookies, biscuits, and crackers secure.",
    onSale: false,
    price: 220,
    countInStock: 22,
    color: "Light Green",
    size: [
      {
        name: "18L",
        description: "Perfect for a reasonable amount of snacks.",
      },
      {
        name: "20L",
        description: "Enough room for a serious amount of snacks.",
      },
    ],
  },
];
